import { getIsMobileOrTablet } from '../../utils/ua'
import dom from '../../utils/dom'

export default function setBodyClasses() {
  let htmlTag = document.documentElement
  htmlTag.classList.remove('no-js')
  htmlTag.classList.add('js')

  if (getIsMobileOrTablet()) {
    htmlTag.classList.add('mobile')
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/documentBodyClassSetter.js